import React from 'react';
import {Page, Text, View, Document} from '@react-pdf/renderer';
import styles from '../../../Process/components/ProjetoGeralEmpreendimento/styles';
import { Header, Footer } from '~/components/PDF';
import InfoTable from '~/components/PDF/InfoTable'
import extractTextFromHTML from '~/utils/extractTextFromHTML';

export default function NotaTecAmbientalPDF({
    process, nota_tec_ambiental
}) {
    return (
        <Document title="Nota Técnica Ambiental">
            <Page size="A4" style={styles.page} wrap>
                <Header
                    logoEntity={process?.entidade?.logo_base64}
                    entityName={process?.entidade?.nome}
                    organName={process?.entidade?.nome_orgao_ambiental}
                    LogoCounty={process?.entidade?.logo_municipio_base64}
                    styles={styles}
                />
                <View style={{ marginTop: '-10px' }}>
                    <Text style={[styles.title, { textAlign: 'center' }]}>
                        Nota Técnica Ambiental
                    </Text>
                </View>
                <View style={styles.section}>
                    <InfoTable 
                        process={process}
                    />
                </View>
                <View style={{ marginTop: '-10px' }}>
                    <Text style={[styles.title, { marginTop: '20px' }]}>
                        ANÁLISE AMBIENTAL
                    </Text>
                    <Text style={[styles.subtitle, { marginTop: '15px' }]}>
                        {extractTextFromHTML(nota_tec_ambiental.analise)}
                    </Text>
                </View>
                <Footer
                    logoSiblam={process?.entidade?.src_siblam_logo_base64}
                    styles={styles}
                />
            </Page>
        </Document>
    );
};